import { render, staticRenderFns } from "./merchants-list.vue?vue&type=template&id=fcdc4688&scoped=true&lang=pug"
import script from "./merchants-list.vue?vue&type=script&lang=ts"
export * from "./merchants-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdc4688",
  null
  
)

export default component.exports